import { render, staticRenderFns } from "./Cancelados.vue?vue&type=template&id=b1e5c81e"
import script from "./Cancelados.vue?vue&type=script&lang=js"
export * from "./Cancelados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports